import { BehaviorSubject, fromEvent, map, throttleTime } from 'rxjs';

export default class ViewportMatcher {
  #matcher: MediaQueryList;
  matches$ = new BehaviorSubject(false);

  constructor(configProvider: any) {
    configProvider.subscribe(
      ({ viewportConstraints }: { viewportConstraints: string }) => {
        if (viewportConstraints === '') {
          this.#matcher = {
            media: 'NO_CONSTRAINT',
            matches: true,
          } as MediaQueryList;
          this.matches$.next(true);
          return;
        }

        this.#matcher = window.matchMedia(viewportConstraints);
        this.matches$.next(this.#matcher.matches);

        fromEvent(this.#matcher, 'change')
          .pipe(
            /* both, site and android apply unexpected transition to our view,
             * but in very own ways.
             * Android webview, and only on landscape to portrait rotate, make:
             * - rotate and applied real size, that does not match constraint;
             * - then resize webview almost to square shape, that match constraint;
             * - then transition them into actual size that does not match constraint
             * An site, instead, on rotate from portrait to landscape, apply incorrect height,
             * based on height in portrait and fix that after 100ms. */
            throttleTime<any>(333),
            map((event: MediaQueryListEvent): boolean => event.matches),
          )
          .subscribe((matches) => {
            this.matches$.next(matches);
          });
      },
    );
  }

  get isMatched() {
    return this.matches$.value;
  }

  get media() {
    return this.#matcher.media;
  }
}
